import {
  deadEndCopy,
  FILTERS_HIDE_SYSTEMS_LEAD,
  recoveryFilterControls,
  recoveryFilterLabels
} from 'data/dead-end-constants';
import {
  DeadEndCopyType,
  RecoveryFilterControlType,
  ValidSystemsDeadEndType,
  ValidSystemsRecoveryFilterType
} from 'types/dead-end';

// What the customer does in the panel to take the named filter off, said
// per control: the API "clears" a filter, but to the customer that is
// turning a switch off, emptying the two price inputs, or checking every
// option of a section again — never unchecking them.
const recoveryActions: Record<
  RecoveryFilterControlType,
  (label: string) => string
> = {
  toggle: (label) => `Turning off "${label}" would show them.`,
  range: (label) => `Clearing the "${label}" limits would show them.`,
  checkboxes: (label) => `Selecting all "${label}" options would show them.`
};

const recoveryActionFor = (filter: ValidSystemsRecoveryFilterType): string =>
  recoveryActions[recoveryFilterControls[filter]](recoveryFilterLabels[filter]);

// The copy for one diagnosis. Per-reason title and hint from deadEndCopy,
// except that a filters dead end which names the one filter whose removal
// brings systems back (deadEnd.filter, spec 001 T005) says what to do about
// it, in the filter panel's own words; without one — stacked filters, or an
// older API — the generic ask stands. T007's "Show systems without <filter>"
// action will act on the same field.
export function deadEndCopyFor(
  deadEnd: ValidSystemsDeadEndType
): DeadEndCopyType {
  const copy = deadEndCopy[deadEnd.reason];
  if (deadEnd.reason !== 'filters_excluded_all' || !deadEnd.filter) {
    return copy;
  }
  return {
    title: copy.title,
    hint: `${FILTERS_HIDE_SYSTEMS_LEAD} ${recoveryActionFor(deadEnd.filter)}`
  };
}
